import {
  ORIGIN_IS_SSO_EVENT_LINK,
  ORIGIN_IS_SSO_EVENT_LINK_VALUE,
} from "../constants";

export const toggleSSOEventLinkSource = (isSSOEventLinkLogin = false): void => {
  // If user is coming from SSO Event login flow: ex: /e/evCode?sso=event-cadence or /e/evCode/sso
  if (isSSOEventLinkLogin) {
    return localStorage.setItem(
      ORIGIN_IS_SSO_EVENT_LINK,
      ORIGIN_IS_SSO_EVENT_LINK_VALUE,
    );
  }

  return localStorage.removeItem(ORIGIN_IS_SSO_EVENT_LINK);
};

export const getIsSSOEventLinkSource = (): boolean =>
  localStorage.getItem(ORIGIN_IS_SSO_EVENT_LINK) ===
  ORIGIN_IS_SSO_EVENT_LINK_VALUE;
